export const DATES_LABEL = 'Reservation Dates'
export const DATES_PATH = 'dates'
export const TRAVELER_LABEL = 'Traveler Info'
export const TRAVELER_PATH = 'traveler'
export const PROTECTION_LABEL = 'Credit Protection'
export const PROTECTION_PATH = 'protection'

export const MODIFY_DATES_BROWSER_TITLE = 'Modify Dates'
export const MODIFY_TRAVELER_BROWSER_TITLE = 'Modify Traveler'
export const MODIFY_PROTECTION_BROWSER_TITLE = 'Modify Protection'
export const EDIT_TEXT = 'Edit'
export const CP_NOT_REQUESTED = 'Not Requested'
export const FAILED_FETCH_ELIGIBILITY = 'Failed to fetch eligibility'
export const CONFIRM_CHANGES = 'Confirm changes'
export const SAME_DAY_SNACKBAR_MESSAGE = 'Check-in and check-out cannot be the same day. Please select a different date.'
export const PAYMENT_METHOD = 'Payment Method'
export const CANCELLATION_UNTIL = 'Free cancellation until'
export const CREDIT_PROTECTION_LABEL = 'Credit Protection'
export const TOTAL_PAYMENT_DUE_LABEL = 'Total payment due'

// Modify traveler review table labels
export const REVIEW_CHANGES_LABEL = 'Review Changes:'
export const MODIFIED_NIGHTS_LABEL = 'Modified nights:'
export const NEW_TRAVELER_LABEL = 'New'
export const OLD_TRAVELER_LABEL = 'Old'
export const MODIFY_MEMBERSHIP_CHARGES = 'Membership charges'
export const MODIFY_OWNERSHIP_CHARGES = 'Ownership charges'
export const MODIFY_PAYMENT_CHARGES = 'Payment charges'
export const MODIFY_TOTAL_PAYMENT_DUE = 'Total payment due'
export const MODIFY_TOTAL_REFUND_DUE = 'Total refund due'
export const MODIFY_PAYMENT_METHOD_LABEL = 'Payment method:'
export const DATES_ARE_LOADING = 'Dates are loading...'
export const ORIGINAL_RESERVATION = 'Original reservation'
export const ADJUSTMENT = 'Adjustment'
export const TOTAL_REQUIRED = 'Total required'
export const CREDITS_PENALIZED = 'Credits penalized'

// Modify traveler review messages
export const GUEST_CONFIRMATION_REQUIRED_MESSAGE = 'Switching from a guest to a guest requires an additional Guest Confirmation.'
export const MODIFICATION_SUCCESS_MESSAGE = 'Your reservation was successfully modified.'
export const getTravelerModificationSuccessMessage = (travelerName: string): string =>
  `You successfully modified your traveler to ${travelerName}.`
export const MODIFICATION_ERROR_MESSAGE = 'Error completing modification'
export const MODIFY_CREDIT_CARD_LABEL = 'Credit Card'

export const MODIFY_CANCEL_CONFIRM_TITLE = 'Are you sure you want to leave?'
export const MODIFY_CANCEL_CONFIRM_TEXT = 'Exiting this page will cancel your reservation modification and you will have to begin the modification process all over again.'
export const MODIFY_CANCEL_CONFIRM_BACK_CTA = 'Yes, Exit Modification'
export const MODIFY_CANCEL_CONFIRM_CANCEL_CTA = 'No, Return To Modification'

export const MODIFY_TIME_UP_TITLE = 'Your timer has expired'
export const MODIFY_TIME_UP_TEXT = "We're sorry, your timer has run out. The 15 minute hold on your reservation change has now expired."
export const MODIFY_TIME_UP_CTA = 'Back to Modification'

// step descriptions
export const CREDIT_PROTECTION_DESCRIPTION = 'Book your vacation with peace of mind. Credit Protection keeps your credits safe in case of a last-minute cancellation.'

// Modify dates calendar tooltip messages
export const MODIFY_DATES_TOOLTIP_SELECT_CHECKIN = 'Select check-in date'
export const MODIFY_DATES_TOOLTIP_SELECT_CHECKOUT = 'Select check-out date'
export const MODIFY_DATES_TOOLTIP_DATE_NOT_SELECTABLE = 'Date not selectable'
export const MODIFY_DATES_TOOLTIP_DISMISS_TIME = 3000
